import styled, { css, keyframes } from 'styled-components';
import _ from 'lodash';
import Text from 'desktop/components/Text';
import Icon from 'desktop/components/Icon';
import { colorVariables } from 'desktop/theme/variables';
import base from './base';

export const ButtonStyled = styled.button`
  ${base};
  // styles depends on buttonStyle prop
  ${(props) =>
    props.buttonStyle === 'transparent' &&
    css`
      background-color: transparent;
    `}
  // styles for disabled button
  ${(props) =>
    props.disable &&
    css`
      cursor: default;
      pointer-events: none;
      opacity: 0.75;
    `}
  // styles for loading button
  ${(props) =>
    props.isLoading &&
    css`
      cursor: default;
    `}

  ${(props) =>
    !props.isMobile &&
    !props.disable &&
    props.buttonStyle === 'transparent' &&
    css`
      &:hover {
        ${StyledIcon} {
          fill: ${!props.isMobile && !props.disable
            ? colorVariables.fire
            : _.get(colorVariables, props.color, colorVariables.fire)};
          transition: 135ms ease-out;
          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            transition: 0ms ease-out;
          }
        }
        ${StyledText} {
          color: ${() => {
            if (!props.isMobile && !props.disable) {
              return css`
                ${_.get(colorVariables, props.hoverColor, colorVariables.fire)};
              `;
            }

            return css`
              ${_.get(colorVariables, props.color, colorVariables.fire)};
            `;
          }};
          transition: 135ms ease-out;
          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            transition: 0ms ease-out;
          }
        }
      }
    `};

  ${(props) =>
    props.buttonStyle === 'transparent' &&
    css`
      &:active {
        ${StyledIcon} {
          fill: ${colorVariables.fire};
          transition: 135ms ease-out;
          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            transition: 0ms ease-out;
          }
        }
        ${StyledText} {
          color: ${_.get(colorVariables, props.hoverColor, colorVariables.fire)};
          transition: 135ms ease-out;
          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            transition: 0ms ease-out;
          }
        }
      }
    `};

  ${(props) =>
    props.disable &&
    css`
      &:active {
        ${StyledIcon} {
          fill: ${colorVariables.gray_darkgray};
          cursor: default;
        }
        ${ButtonStyled} {
          color: ${_.get(colorVariables, props.color, colorVariables.orange)};
          cursor: default;
        }
      }
    `};
`;

export const StyledText = styled(Text)`
  transform: translate(0, 1px);
  // styles depends on buttonStyle prop
  ${(props) =>
    props.buttonStyle === 'transparent' &&
    css`
      color: ${_.get(colorVariables, props.color, colorVariables.fire)};
    `};
`;

export const StyledIcon = styled(Icon)`
  // hover only when not disabled or mobile
  ${(props) =>
    props.separation &&
    css`
      margin-right: ${props.separation}px;
    `};
  // styles depends on buttonStyle prop
  ${(props) =>
    props.buttonStyle === 'transparent' &&
    css`
      fill: ${_.get(colorVariables, props.color, colorVariables.fire)};
    `};
  // styles for disabled button
  ${(props) =>
    props.disable &&
    css`
      fill: ${colorVariables.gray_darkgray};
      cursor: default;
    `};
  // styles for active button
  ${(props) =>
    props.active &&
    css`
      fill: ${colorVariables.fire};
    `};
`;

export const ContentWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  // styled depends on align props
  ${(props) =>
    props.align === 'left' &&
    css`
      justify-content: flex-start;
    `};
`;

const Rotate = keyframes`
  from {
    transform: rotate(-42deg);
  }
  to {
    transform: rotate(318deg);
  }
`;

export const Loader = styled.svg`
  position: relative;
  width: 22px;
  height: 22px;
  transform-origin: center center;
  transform: rotate(-42deg);
  animation: ${Rotate} 915ms linear infinite;
`;

export const LoaderCircle = styled.circle`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  stroke-linecap: round;
  stroke: white;
  stroke-width: 3px;
`;
